var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col relative flex-grow overflow-hidden print:block"},[_c('router-view',{key:_vm.$route.fullPath}),(_vm.isInFlight || _vm.isOnNewReportPage)?_c('div',{staticClass:"absolute top-0 left-0 w-full h-full -z-1"},[_c('div',{staticClass:"background-wrapper",class:[
        { 'background-wrapper--step1': _vm.isOnNewReportPage },
        { 'background-wrapper--step2': _vm.isInFlight && !_vm.isOnNewReportPage },
      ]},[_c('BackgroundImage',{staticClass:"background"})],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }